<div class="onboarding">
    <div class="semi-background">
        <div class="col-md-10 mx-auto">
            <token-header></token-header>

            <div class="content mt-0 mt-md-3">
                <div class="token-content py-5">
                    <div class="pt-3">
                        <h4 class="text-center message-icon"><i class="fa-regular fa-timer fa-2x"></i></h4>
                        <h4 class="text-center">{{ 'onboarding.token.expired_token.title' | translate}}</h4>
                        <p class="text-center">{{ 'onboarding.token.expired_token.description' | translate}}</p>
                        <div class="text-center mt-3">
                            <button class="btn btn-primary btn-lg" (click)="newToken(token)">{{ 'onboarding.token.expired_token.action' | translate}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>